import { useQuery } from '@tanstack/react-query';
import campaignService from 'v2/services/campaigns';

export function useListPostback(productId: number, destiny: string, type: string) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['postback', productId, destiny, type],
    queryFn: () => campaignService.listPostback(productId, destiny, type),
    enabled: !!productId
  });

  return { data, isLoading, error, refetch };
}
